import CustomField from "components/common/CustomField";
import CustomLabel from "components/common/CustomLabel";
import FormButtons from "components/common/FormButtons";
import IsLoading from "components/common/IsLoading";
import { updateOrganizationManagerSchema } from "components/common/Validation";
import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import {
  getOrganizationManagerDetails,
  updateOrganizationManager,
} from "store/actions/organizationSlice";
import { showAlert } from "store/reducers/alertReducer";

const initialValues = {
  subdomain: "",
  appBundleId: "",
  code: "",
};

const UpdateOrganizationManager = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [formValues, setFormValues] = useState(initialValues);

  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const { gettingDetails2, isLoading, organizationManagerDetails } =
    useSelector((state) => state.Organizations);

  useEffect(() => {
    const getDetails = () => {
      const payload = {
        id,
      };
      dispatch(getOrganizationManagerDetails(payload));
    };
    getDetails();
  }, []);

  useEffect(() => {
    if (organizationManagerDetails && !gettingDetails2) {
      const {
        subdomain = "",
        appBundleId = "",
        code,
      } = organizationManagerDetails || {};

      setFormValues({ subdomain, appBundleId, code });
    }
  }, [organizationManagerDetails, gettingDetails2]);

  const handleOnSubmit = (values) => {
    const { subdomain, appBundleId } = values || {};
    const payload = {
      id,
      subdomain,
      appBundleId,
    };
    dispatch(updateOrganizationManager(payload))
      .then((action) => {
        const { statusCode, success, message } = action?.payload || {};
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }));
        } else {
          dispatch(showAlert({ text: message, type: "error" }));
        }
      })
      .catch((err) => {});
  };

  return (
    <div>
      {gettingDetails2 ? (
        <IsLoading />
      ) : (
        <Formik
          initialValues={formValues}
          validationSchema={updateOrganizationManagerSchema}
          enableReinitialize
          onSubmit={handleOnSubmit}
        >
          {({ errors, values, touched, setFieldValue }) => (
            <Form>
              <div className="common_wrapper">
                <Row>
                  <Col lg={6}>
                    <div className="form_field">
                      <CustomLabel htmlFor="subdomain" label={t("Subdomain")} />
                      <CustomField
                        name="subdomain"
                        type="text"
                        placeholder={t("Enter Subdomain")}
                        touched={touched.subdomain}
                        errors={errors.subdomain}
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form_field">
                      <CustomLabel
                        htmlFor="appBundleId"
                        label={t("App Bundle Id")}
                      />
                      <CustomField
                        name="appBundleId"
                        type="text"
                        placeholder={t("Enter App Bundle Id")}
                        touched={touched.appBundleId}
                        errors={errors.appBundleId}
                      />
                    </div>
                  </Col>
                  {/* <Col lg={6}>
                    <div className="form_field">
                      <CustomLabel htmlFor="code" label={t("Code")} />
                      <CustomField name="code" type="text" isReadOnly={true} />
                    </div>
                  </Col> */}
                  <Col lg={12}>
                    <div className="mt-3">
                      <FormButtons
                        isLoading={isLoading}
                        addBtnText={t("Update")}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </Form>
          )}
        </Formik>
      )}
    </div>
  );
};

export default UpdateOrganizationManager;
